var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18C18 19.103 17.103 20 16 20H4C2.897 20 2 19.103 2 18V9C2 7.897 2.897 7 4 7H5H15H16C17.103 7 18 7.897 18 9V18ZM7 3C7 2.458 7.458 2 8 2H12C12.542 2 13 2.458 13 3V5H7V3ZM16 5H15V3C15 1.35 13.65 0 12 0H8C6.35 0 5 1.35 5 3V5H4C1.8 5 0 6.8 0 9V18C0 20.2 1.8 22 4 22H16C18.2 22 20 20.2 20 18V9C20 6.8 18.2 5 16 5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.4444b6363e718cf163eed63e4f136089.svg";
export { ForwardRef as ReactComponent };